import { createContext, useContext } from 'react';

export const OfficeContext = createContext<{
  isExcel?: boolean;
  isPowerPoint?: boolean;
  isOfficeOnline?: boolean;
  officeHost?: Office.HostType;
  officePlatform?: Office.PlatformType;
}>({});

export const useOfficeContext = () => useContext(OfficeContext);
